// extracted by mini-css-extract-plugin
var _1 = "RightMenu_loginPageRightMenuContainer__Pu8ZB";
var _2 = "RightMenu_rightMenuContainer__TD2iW";
export { _1 as "loginPageRightMenuContainer", _2 as "rightMenuContainer" }
